import React from "react";
import Link from "../Link";
import styles from "./TableOfContents.module.css";

type TableOfContentsItem = {
  label: string;
  href: string;
};

type TableOfContentsProps = {
  items: TableOfContentsItem[];
  singleColumn?: boolean;
};

const TableOfContents = ({ items, singleColumn }: TableOfContentsProps) => {
  return (
    <div className={styles.tableContentsWrapper}>
      <div
        className={
          singleColumn ? styles.tableContentsListCentered : styles.tableContentsListColumns
        }
      >
        {items.map(item => (
          <Link key={item.label} href={item.href} className={styles.tableContentsListItem}>
            {item.label}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default TableOfContents;
